function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "icons/basic/location"
}, React.createElement("path", {
  id: "Subtract",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.9831 14.2505C23.9831 18.735 18.0852 25.4238 16.597 25.4238C14.8978 25.4238 9 18.735 9 14.2505C9 9.95776 12.354 6.40002 16.597 6.40002C20.6289 6.40002 23.9831 9.95776 23.9831 14.2505ZM16.5 17C18.433 17 20 15.433 20 13.5C20 11.567 18.433 10 16.5 10C14.567 10 13 11.567 13 13.5C13 15.433 14.567 17 16.5 17Z",
  fill: "#222222"
}));

var SvgLocation = function SvgLocation(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Imljb25zL2Jhc2ljL2xvY2F0aW9uIj4KPHBhdGggaWQ9IlN1YnRyYWN0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIzLjk4MzEgMTQuMjUwNUMyMy45ODMxIDE4LjczNSAxOC4wODUyIDI1LjQyMzggMTYuNTk3IDI1LjQyMzhDMTQuODk3OCAyNS40MjM4IDkgMTguNzM1IDkgMTQuMjUwNUM5IDkuOTU3NzYgMTIuMzU0IDYuNDAwMDIgMTYuNTk3IDYuNDAwMDJDMjAuNjI4OSA2LjQwMDAyIDIzLjk4MzEgOS45NTc3NiAyMy45ODMxIDE0LjI1MDVaTTE2LjUgMTdDMTguNDMzIDE3IDIwIDE1LjQzMyAyMCAxMy41QzIwIDExLjU2NyAxOC40MzMgMTAgMTYuNSAxMEMxNC41NjcgMTAgMTMgMTEuNTY3IDEzIDEzLjVDMTMgMTUuNDMzIDE0LjU2NyAxNyAxNi41IDE3WiIgZmlsbD0iIzIyMjIyMiIvPgo8L2c+Cjwvc3ZnPgo=";
export { SvgLocation as ReactComponent };